'use strict';
//Jquery
//import $ from "jquery";
// jquery importuojamas globaliai webpack

//Bootstrap
//import Bootstrap from 'bootstrap';
//import "bootstrap/dist/css/bootstrap.css";

//Slick slider
import SlickSlider from 'slick-slider';
import "slick-slider/slick/slick.css";

//moment
import moment from 'moment';
moment.locale('lt');

//pikaday
import Pikaday from 'pikaday';
import "pikaday/css/pikaday.css";

//tooltipster
import Tooltipster from 'tooltipster';
import "tooltipster/dist/css/tooltipster.bundle.css";

import { Fancybox } from "@fancyapps/fancybox";
import "@fancyapps/fancybox/dist/jquery.fancybox.css";

import select2 from 'select2';
import "select2/dist/css/select2.css";

import 'jquery-validation';
import 'jquery-validation/dist/localization/messages_lt';

import '../lib/lightgallery/js/lightgallery.ew4.js';

import '../lib/jquery-nicefileinput/jquery.nicefileinput.js';
import '../lib/javascript-equal-height-responsive-rows/grids.js';

import 'jquery.highlight-bartaz';

import html2canvas from 'html2canvas';

import { globalJsTranslations } from '../services/globaljstranslations.js';
import { hashController } from '../controllers/hashcontroller.js';

window.$ = $;

$(document).ready(function () {
	if (!$("#popup_window").length) { // init if not in dialog view
		select2init();
//		mobile_sidebar();
		fancybox();
		validate();
		slick_carousel();
		gallery_hash();
		youtube_hash();
		fixed_header();
		print_v();
		highlight_search_results();
		init_questions_toggler_hash();
		catalog_gallery();
		file_input();
		iframe_adaptability();
		reportbug_form();
		show_more();
		postformwidget_validate();
		init_contacts();
		tooltipster();

		sidebar_menu();
		scroll_top();

		set_widgetcalendar_data();
		showDayEvent();
		EventCalendar();
		toggle_items();
		loadTitlepageCalendar();
		addAriaLabels();
		pikaday();
		langToggle();
		navToggle();
		toggle_search_popup();
		formControl();
		contactsControl();
	}
});

$(window).on('load', function () {
	$('.equalheight').responsiveEqualHeightGrid();
	if ($(window).width() < 768) {
		mobile_overflow_tables();
	}
	addAriaLabelToMobileMenu();
	$('.do-screenshot').click(function () {
		markSpot();
	});

});

function select2init() {
	$("select").select2({
		"minimumResultsForSearch": -1
	});

	// use this class if placeholder is needed. 
	// Translation added as data attribute: <select data-placeholder="{'choise_value'|t}">
	// Also, first option in select element has to be empty: <option value=""></option>
	$("select.select2_with_dynamic_placeholder").select2({
		"minimumResultsForSearch": -1,
		placeholder: function () {
			$(this).data('placeholder');
		}
	});
}

function slick_carousel() {

	$('.slidesvideos-slider').each(function () {
		var $slider = $(this);

		$slider
				.on('init beforeChange afterChange reInit setPosition', function (event, slick, currentSlide, nextSlide) {
					setTimeout(function () {
						slick.$slides.removeAttr('aria-hidden');

						slick.$slides.not('.slick-current')
								.find('a, button, input, select, textarea, iframe, [tabindex]')
								.attr('tabindex', '-1');

						slick.$slides.filter('.slick-current')
								.find('a, button, input, select, textarea, iframe')
								.attr('tabindex', '0');

						$slider.find('.slick-dots li button').attr('tabindex', '0');
					}, 0);
				})
				.slick({
					dots: true,
					arrows: false,
					infinite: true,
					autoplay: false,
					speed: 500,
					fade: true,
					cssEase: 'linear',
					rows: 0,
					accessibility: false
				});
	});

	if ($(".news-slider").length) {
		$('.news-slider')
				.on('init beforeChange afterChange reInit setPosition', function (event, slick, currentSlide, nextSlide) {
					setTimeout(function () {
						slick.$slides.removeAttr('aria-hidden');

						slick.$slides.not('.slick-current')
								.find('a, button, input, select, textarea, iframe, [tabindex]')
								.attr('tabindex', '-1');

						slick.$slides.filter('.slick-current')
								.find('a, button, input, select, textarea, iframe')
								.attr('tabindex', '0');
					}, 0);
				})
				.slick({
					slidesToShow: 2.5,
					slidesToScroll: 1,
					arrows: true,
					dots: false,
					infinite: false,
					autoplay: true,
					autoplaySpeed: 3000,
					responsive: [
						{
							breakpoint: 1024,
							settings: {slidesToShow: 2}
						},
						{
							breakpoint: 768,
							settings: {slidesToShow: 1.5}
						},
						{
							breakpoint: 480,
							settings: {slidesToShow: 1}
						}
					]
				});
		$('.news-slider-prev').click(() => $('.news-slider').slick('slickPrev'));
		$('.news-slider-next').click(() => $('.news-slider').slick('slickNext'));
	}

	if ($(".banners-slider").length) {
		$('.banners-slider').slick({
			slidesToShow: 1.5,
			slidesToScroll: 1,
			infinite: false,
			arrows: false,
			dots: false,
			autoplay: true,
			autoplaySpeed: 3000,
			responsive: [
				{
					breakpoint: 1024,
					settings: {slidesToShow: 1.5}
				},
				{
					breakpoint: 768,
					settings: {slidesToShow: 1}
				},
				{
					breakpoint: 480,
					settings: {slidesToShow: 1}
				}
			]
		});
		$('.banners-slider-prev').click(() => $('.banners-slider').slick('slickPrev'));
		$('.banners-slider-next').click(() => $('.banners-slider').slick('slickNext'));
	}

	if ($(".promoblock_slider").length) {
		$('.promoblock_slider').slick({
			dots: false,
			arrows: true,
			infinite: true,
			slidesToShow: 6,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 5,
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 4,
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 420,
					settings: {
						slidesToShow: 2,
					}
				}],
			slidesToScroll: 1,
			speed: 180,
			cssEase: 'linear',
			rows: 0
		});
	}
}


function fancybox() {
	// FB3 docs: https://fancyapps.com/fancybox/3/docs
	//  Translations inside libs/localization/

	// News preview
	$("a.news_image").fancybox({
		btnTpl: {
			zoom: false
		}
	});

	// News gallery 
	$("a.fancybox_gallery").fancybox({
		thumbs: false,
		transitionEffect: "slide",
		clickContent: false,
		btnTpl: {
			zoom: false
		}
	});

	// From Tinymce
	$("a[rel=fancybox]").fancybox({
		btnTpl: {
			zoom: false
		}
	});
	// From Tinymce
	$("a[rel=fancybox-images]").fancybox({
		btnTpl: {
			zoom: false,
			slideShow: false,
			thumbs: false,
		}
	}).attr('data-fancybox', 'images');

	// Ajax call
	$("a.fancybox_ajax").fancybox({
		type: "ajax",
		touch: false // disable drag cursor
	});

	// Iframe call
	$("a.fancybox_iframe").fancybox({
		type: "iframe",
		touch: false // disable drag cursor
	});

//	$(".contacts__list-item").fancybox({
//		touch: false,
//		smallBtn: true,
//		toolbar: false,
//		buttons: ["close"],
//		autoFocus: false,
//		baseClass: "contacts-fancybox-modal", // Add custom class to the modal
//		afterShow: function (instance, current) {
//			$(".fancybox-container").addClass("custom-modal-class"); // Extra custom class if needed
//		}
//	});
}

function gallery_popup() {
	$('.gallery_popup').on("click", function () {
		$(".album_loading").show();
		var $this = $(this);
		var url = $(this).data("fancy-link");
		$.ajax({
			url: url,
			type: "GET",
			success: function (data) {
				$(".album_loading").fadeOut("fast");
				var photos = [];
				$.each(data.photos, function (i) {
					var obj = {
						"src": this.img_itemimage,
						"thumb": this.img_itemimage_thumb
					};
					if (this.title) {
						obj.subHtml = '<div class="photo_title">' + this.title + '</div>';
					}
					photos.push(obj);
				});
				$this.lightGallery({
					dynamic: true,
					dynamicEl: photos,
					speed: 300,
					hideBarsDelay: 1000,
					closable: false,
					loop: false,
					download: false,
					enableDrag: false,
					thumbWidth: 112,
					thumbContHeight: 83,
					thumbMargin: 10,
					toogleThumb: false,
					galleryId: $this.data("id")
				});
				$this.on('onAfterOpen.lg', function (event, index, fromTouch, fromThumb) {
					$(".lg").append("<div class='album_title lg-toolbar'><div class='album_title_text'>" + data.title + "</div></div>")
				});
			},
			error: function () {
				$(".album_loading").fadeOut("fast");
				alert('Load error.');
			}
		});


	});
}

function youtube_popup() {
	$('.youtube_popup').on("click", function () {

		$(".album_loading").show();
		var $this = $(this);
		var url = $(this).data("fancy-link");
		$.ajax({
			url: url,
			type: "GET",
			success: function (data) {
				$(".album_loading").fadeOut("fast");
				var photos = [];
				var obj = {
					"src": data.youtube_share_link,
					"thumb": data.img_itemimage_thumb,
					//"poster":  data.img_itemimage_thumb
				};
				if (data.title) {
					obj.subHtml = '<div class="photo_title">' + data.title + '</div>';
				}
				photos.push(obj);
				$this.lightGallery({
					dynamic: true,
					dynamicEl: photos,
					speed: 300,
					hideBarsDelay: 1000,
					closable: false,
					loop: false,
					download: false,
					enableDrag: false,
					thumbWidth: 112,
					thumbContHeight: 83,
					thumbMargin: 10,
					toogleThumb: false,
					//youtubePlayerParams: {autoplay:0 },
					counter: false,
					videoMaxWidth: '900px',
					addClass: "youtubegallery_popup",
					fullScreen: false
				});
			},
			error: function () {
				$(".album_loading").fadeOut("fast");
				alert('Load error.');
			}
		});


	});
}

function validate() {
	var options = {
		highlight: function (element, errorClass, validClass) {
			if ($(element).closest(".type_item").length) {
				$(element).closest(".type_item").removeClass(validClass).addClass(errorClass);
			}
		},
		unhighlight: function (element, errorClass, validClass) {
			if ($(element).closest(".type_item").length) {
				$(element).closest(".type_item").removeClass(errorClass).addClass(validClass);
			}
		},
		errorPlacement: function (error, element) {
			$(element).closest(".type_item").find('.type_error').append(error);
		},
	}
	if ($("#forms_form").length) {
		$("#forms_form").validate(options);
		$("#forms_form select").change(function () {
			$(this).valid();
		});
		$("#forms_form input[type='file']").change(function () {
			$(this).valid();
		});
	}
	if ($("#jobadsform").length) {
		$("#jobadsform").validate(options);
		$("#jobadsform input[type='file']").change(function () {
			$(this).valid();
		});
	}
	if ($("#letter_form").length) { // Postform
		$("#letter_form").validate(options);
	}
	if ($("#poll_form").length) {
		$("#poll_form").validate(options);
		$("#poll_form select").change(function () {
			$(this).valid();
		});
		$("#poll_form input[type='file']").change(function () {
			$(this).valid();
		});
	}
	if ($("#subscription_form").length) {
		$("#subscription_form").validate(options);
	}
	if ($("#poll_widget").length) {
		$("#poll_widget").validate(options);
	}
	if ($("#sitelogin_widget").length) {
		$("#sitelogin_widget").validate(options);
	}
	if ($("#duk_form").length) {
		$("#duk_form").validate(options);
	}
	if ($(".comment-form").length) {
		$(".comment-form").validate(options);
	}
	if ($("#sitelogin_form").length) {
		$("#sitelogin_form").validate(options);
	}
	if ($("#faq_form").length) {
		$("#faq_form").validate(options);
	}
	if ($("#subscription_form_index").length) {
		$("#subscription_form_index").validate(options);
	}
	if ($("#remind_pass_form").length) {
		$("#remind_pass_form").validate(options);
	}

	if ($('#custom_validate').length) {
		$("#custom_validate").validate(options);
		$("#custom_validate select").change(function () {
			$(this).valid();
		});
		$("#custom_validate input[type='file']").change(function () {
			$(this).valid();
		});
	}
}

/**
 * Alias for hashController
 * @type @exp;hashController
 */
window.hc = hashController;

/**
 * @example hc.register({callback: function(e, h){
 *			console.log(h.get());
 *		}});
 *
 *		hc.set('raudona');
 */

$(document).ready(function () {
	hc.trigger();
});

function galleryWrapper() {
	this.photos = new Array();
	this.album_data;
	this.album_id;
	this.photo_id = '';
	this.dataUrl = '';
	this.isOpen = false;
	this.base_url = location.pathname + '/';
	this.hcb;

	this.gallery_options = {
		dynamic: true,
		speed: 300,
		hideBarsDelay: 2000,
		closable: false,
		loop: true,
		download: false,
		enableDrag: false,
		thumbWidth: 112,
		thumbContHeight: 93,
		thumbMargin: 10,
		showAfterLoad: false,
		toogleThumb: false,
		galleryId: this.album_id
	};

	if (arguments[0] && typeof (arguments[0]) === 'object') {
		$.extend(this.gallery_options, arguments[0]);
	}

	var self = this;

	this.getElement = function () {
		if (!document.getElementById(this.album_id)) {
			$('body').append('<div id="' + this.album_id + '" style="display:none;"></div>');
		}
		return $('#' + this.album_id);
	};

	this.init = function () {
		if (!this.isOpen) {
			$(".album_loading").show();
			$.ajax({
				url: this.dataUrl,
				type: "GET",
				dataType: "json",
				contentType: "application/json",
				success: function (data) {
					self.album_data = data;
					self.setPhotos(data);
					if (self.photos.length > 0) {
						self.initgallery();
						$(".album_loading").fadeOut("fast");
					} else {
						$(".album_loading").fadeOut("fast");
						self.close();
					}
				},
				error: function () {
					$(".album_loading").fadeOut("fast");
					alert('Load error.');
				}
			});
		}
	};

	this.setPhotos = function (data) {
		if (typeof (data.photos) !== 'undefined') {
			for (var i = 0; i < data.photos.length; i++) {
				var obj = {
					src: ($(window).width() > 800 ? data.photos[i].img__original : data.photos[i].img_itemimage)
				};
				if (typeof (data.photos[i].img_itemimage_thumb) !== 'undefined') {
					obj.thumb = data.photos[i].img_itemimage_thumb;
				} else {
					obj.thumb = data.photos[i].img_listimage;
				}
				if (data.photos[i].title) {
					obj.subHtml = '<div class="photo_title">' + data.photos[i].title + '</div>';
				}
				self.photos.push(obj);
			}
		}
	};

	this.initgallery = function () {
		var cont = this.getElement();
		if (this.photo_idx > 0 && this.photos.length > this.photo_idx) {
			this.gallery_options.index = this.photo_idx;
		}
		this.gallery_options.dynamicEl = this.photos;
		this.gallery_options.galleryId = this.album_id;
		$(cont).lightGallery(this.gallery_options);
		this.isOpen = true;
		this.galleryEvents(cont);
	};

	this.galleryEvents = function (cont) {
		$(cont).on('onAfterOpen.lg', function () {
			if ($("#album_title").length) {
				$("#album_title").html(self.album_data.title);
			} else {
				$(".lg").append("<div class='album_title lg-toolbar'><div id='album_title' class='album_title_text'>" + self.album_data.title + "</div></div>");
			}
			if (!$(".gallery_share").length) {
				$(".lg-toolbar.group").append("<div class='gallery_share'><div class='share_icon'></div><div class='share_drop'><div class='share_fb'></div><div class='share_gplus'></div></div></div>");
				//$("<div class='gallery_share'><div class='share_icon'></div><div class='share_drop'><div class='share_fb'></div><div class='share_gplus'></div></div></div>").insertAfter(".lg-fullscreen");

				$(".lg-outer").on("click", function () {
					$(".share_drop").slideUp("fast");
					$(".share_icon").removeClass("active");
				});
				$(".share_icon").on("click", function (e) {
					$(this).addClass("active");
					e.stopPropagation();
					$(this).parent().find(".share_drop").slideToggle("fast");
				});

				$(".share_fb").on("click", function (e) {
					$(".share_drop").slideUp("fast");
					$(".share_icon").removeClass("active");
					window.open("https://www.facebook.com/sharer/sharer.php?u=" + escape(window.location.href), 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');
					return false;
				});
				$(".share_gplus").on("click", function (e) {
					$(".share_drop").slideUp("fast");
					$(".share_icon").removeClass("active");
					window.open("https://plus.google.com/share?url=" + escape(window.location.href), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');
					return false;
				});
			}
			if (self.photo_idx > 0) {
				$(cont).data('lightGallery').slide(self.photo_idx);
			}
		});
		$(cont).on('onCloseAfter.lg', function () {
			self.hcb.hashObj.clear();
			self.close();
		});
		$(cont).on('onAfterSlide.lg', function (event, index, fromTouch, fromThumb) {
			self.hcb.hashObj.replace('!' + self.album_id + '/photo' + $(cont).data('lightGallery').index);
//			setTimeout(function(){self.ignore(false);}, 50);
		});
	};

	this.route = function (e, hcb) {
		this.hcb = hcb;
		var parts = this.hcb.hashObj.get().replace(/^\!/, '').split('/');
		this.album_id = parts[0];

		this.dataUrl = this.getUrl();

		this.ignore(true);
		if (parts.length > 1 && /^photo[0-9]+$/.test(parts[1])) {// && typeof(this.photos_index[parts[1]]) !== 'undefined'){
			var nr = parts[1].replace(/^photo([0-9]+)$/, '$1');
			if (!this.isOpen && this.photo_idx != nr) {
				this.photo_idx = parseInt(nr);
			}
//			else if(this.isOpen){
//				var cont = this.getElement();
//				console.log(parseInt(nr));
//				$(cont).data('lightGallery').slide(parseInt(nr));
//			}
		}
		if (!this.isOpen) {
			this.init();
		}
	};

	this.close = function () {
		this.ignore(false);
		this.photos = new Array();
		this.album_data = null;
		this.album_id = '';
		this.dataUrl = '';
		this.photo_idx = '';
		this.isOpen = false;
		//this.hcb = null;
	};

	this.ignore = function () {
		this.hcb.lock = !!arguments[0];
	};
	this.isIgnored = function () {
		return !!this.hcb.lock;
	};
	this.getUrl = function () {
		var url = this.getElement().data('url');
		if (!url || url === '') {
			url = this.base_url + this.album_id;//location.pathname + '/albumdata/' + this.album_id;
		}
		return url;
	};
	//this.route();
}
;

function gallery_hash() {
	var wr = new galleryWrapper();
	wr.base_url = location.pathname + '/albumdata/';
	hc.register({
		callback: function (e, hcb) {
			wr.route(e, hcb);
		},
		rule: new RegExp("^\!album[0-9]+(/photo[0-9]+)*$")
	});
	$('.gallery_list, .search_results, .assoc_gallery_cont').on("click", ".gallery_popup", function () {
		location.hash = '!' + $(this).attr('id');
	});

}

function youtube_hash() {

	var wry = new galleryWrapper({
		loop: false,
		youtubePlayerParams: {
			//autoplay: 0,
			rel: 0/*,
			 showinfo: 0*/
		},
		counter: false,
		videoMaxWidth: '900px',
		addClass: "youtubegallery_popup",
		fullScreen: false
	});

	wry.base_url = location.pathname + '/itemdata/';

	wry.setPhotos = function (data) {
		var obj = {
			src: data.youtube_share_link,
			thumb: data.imgthumbnail//,
					//poster: data.imgposter // reikalingas jei norim autoplay=0
		};
		if (data.title) {
			obj.subHtml = '<div class="photo_title">' + data.title + '</div>';
		}
		wry.photos.push(obj);
	};

	wry.galleryEvents = function (cont) {
		$(cont).on('onCloseAfter.lg', function () {
			wry.hcb.hashObj.clear();
			wry.close();
		});
	};

	hc.register({
		callback: function (e, hcb) {
			wry.route(e, hcb);
		},
		rule: new RegExp("^\!yt[0-9]+$")
	});
	$('.youtube_list, .search_results, .assoc_gallery_cont').on("click", ".youtube_popup", function () {
		location.hash = '!' + $(this).attr('id');
	});
}

function getMoreNews(url) {
	$('.more_btn_cont').remove();
	$('.loader_content').show();
	$.ajax({
		url: url,
		cache: false
	}).done(function (html) {
		$('.news_list').append(html);
		imagesLoaded($('.news_list'), function () {
			equalheight_list_items('.equalheight');
		});
		$('.loader_content').hide();
	});
}

function getMoreAlbums(url) {
	$('.more_btn_cont').remove();
	$('.loader_content').show();
	$.ajax({
		url: url,
		cache: false
	}).done(function (html) {
		$('.gallery_list').append(html);
		imagesLoaded($('.gallery_list'), function () {
			equalheight_list_items('.equalheight');
		});
		$('.loader_content').hide();
	});
}

function getMoreVideos(url) {
	$('.more_btn_cont').remove();
	$('.loader_content').show();
	$.ajax({
		url: url,
		cache: false
	}).done(function (html) {
		$('.youtube_list').append(html);
		imagesLoaded($('.youtube_list'), function () {
			equalheight_list_items('.equalheight');
		});
		$('.loader_content').hide();
	});
}


window.isMobile = {
	Android: function () {
		return navigator.userAgent.match(/Android/i);
	},
	BlackBerry: function () {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	iOS: function () {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	Opera: function () {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	Windows: function () {
		return navigator.userAgent.match(/IEMobile/i);
	},
	any: function () {
		return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
	}
};


function fixed_header() {
	$('.container-fluid').click(function () {
		$(".langs_drop_cont").slideUp("fast");
		$(".langs_cont").removeClass("dropped");
	});

	$(".current_lang_cont").click(function (e) {
		e.stopPropagation();
		$(this).parent().toggleClass("dropped");
		$(this).parent().find(".langs_drop_cont").slideToggle("fast");
	});

	// Fixes the fixed header in iOS
	if (isMobile.iOS()) {
		var $body;
		if ('ontouchstart' in window) {
			$body = $("body");
			document.addEventListener('focusin', function () {
				return $body.addClass("fixfixed");
			});
			return document.addEventListener('focusout', function () {
				$body.removeClass("fixfixed");
				return setTimeout(function () {
					return $(window).scrollLeft(0);
				}, 20);
			});
		}
	}

}

function print_v() {
	$(".print_button").click(function () {
		window.print();
	});
}

function highlight_search_results() {
	if ($('#search_results_container').length > 0) {
		var query = $('#search_results_container').attr('data-text');
		if (typeof (query) !== 'undefined' && query !== '') {
			$('#search_results_container').highlight(query);
		}
	}

}

function init_questions_toggler_hash() {

	var $ct = $('.category-title');
	var $tt = $('.topic-title');
	var offset = ($('.fixed_header').is(':visible')) ? 50 : 0;

	var self = this;

	function getArgs() {
		var query = window.location.hash;
		query = query.substr(1)
		var args = new Array();
		query.split("/").forEach(function (part) {
			var item = part.split("-");
			args[item[0]] = item[1];
		});
		return args;
	}

	var args = getArgs();

	if (typeof args['c'] !== 'undefined') {
		$('[data-category-id="' + args['c'] + '"]').find('.category-title').attr('data-category-role', 'open').next('.topics').removeClass('hidden').addClass('visible');
		$('[data-category-id="' + args['c'] + '"]').next('.topics').slideDown("fast");
	}

	if (typeof args['t'] !== 'undefined') {
		$('[data-topic-id="' + args['t'] + '"]').attr('data-topic-role', 'open').next('.topic-description').removeClass('hidden').addClass('visible');
		$('[data-topic-id="' + args['t'] + '"]').next('.topic-description').slideDown("fast");
	}

	function hide(sel) {
		return sel.slideUp("fast").removeClass('visible').addClass('hidden');
	}

	function show(sel) {
		return sel.slideDown("fast").removeClass('hidden').addClass('visible');
	}

	function ctEvent() {
		$ct.on('click keypress', function (e) {
			if (e.type === 'click' || (e.type === 'keypress' && e.which === 13)) {
				if ($(this).attr('data-category-role') === 'close') {
					var cur = $(this);
					hide($ct.attr('data-category-role', 'close').next('.topics')).not($(this));
					hide($tt.attr('data-topic-role', 'close').next('.topic-description'));
					show($(this).attr('data-category-role', 'open').next('.topics'));
					window.location.hash = '#c-' + $(this).attr('data-category-id');
				} else if ($(this).attr('data-category-role') === 'open') {
					hide($ct.attr('data-category-role', 'close').next('.topics'));
					hide($tt.attr('data-topic-role', 'close').next('.topic-description'));
					hide($(this).attr('data-category-role', 'close').next('.topics'));
					history.pushState("", document.title, window.location.pathname + window.location.search);
				}
			}
		});
	}

	function ttEvent() {
		$tt.on('click keypress', function (e) {
			if (e.type === 'click' || (e.type === 'keypress' && e.which === 13)) {

				if ($(this).attr('data-topic-role') === 'close') {
					var cur = $(this);
					hide($('.no-topics')).prev('.category-title').attr('data-category-role', 'close');
					hide($tt.parent('.topics:not(.show)').not($(this).parent()));
					$tt.parent().prev('.category-title').not($(this).parent().prev('.category-title')).attr('data-category-role', 'close');
					hide($tt.not($(this)).attr('data-topic-role', 'close').next('.topic-description').not($(this).next('.topic-description')));
					show($(this).attr('data-topic-role', 'open').next('.topic-description'));
					history.pushState("", document.title, window.location.pathname + window.location.search + '#c-' + $(this).attr('data-category-id') + '/' + 't-' + $(this).attr('data-topic-id'));
				} else if ($(this).attr('data-topic-role') === 'open') {
					hide($('.no-topics')).prev('.category-title').attr('data-category-role', 'close');
					hide($tt.parent('.topics:not(.show)').not($(this).parent()));
					$tt.parent().prev('.category-title').not($(this).parent().prev('.category-title')).attr('data-category-role', 'close');
					hide($tt.not($(this)).attr('data-topic-role', 'close').next('.topic-description').not($(this).next('.topic-description')));
					hide($(this).attr('data-topic-role', 'close').next('.topic-description'));
					window.location.hash = '#c-' + $(this).attr('data-category-id');
				}
			}
		});
	}

	function initEvents() {
		ctEvent();
		ttEvent();
	}

	initEvents();
}



function catalog_gallery() {
	$(".catalog_gallery a").click(function (e) {
		e.preventDefault();
		e.stopPropagation();
		$(".catalog_gallery a").removeClass("active_ph");
		$(this).addClass("active_ph");
		$("a.full_photo_preview").removeClass("current_photo");
		$(".main_photo a.photo" + $(this).data("href")).addClass("current_photo");
	});
}


function file_input() {
    var langAttribute = $('html').attr('lang') || 'en';
    var label;
    if (langAttribute === 'lt') label = 'Pasirinkite failus';
    else if (langAttribute === 'en') label = 'Browse';
    else label = 'Pasirinkite failus';

    $('input[type=file]').nicefileinput({ label: label });

    $(document).on('change', 'input[type=file]', function () {
        var parentDiv = $(this).closest('.no-margin.type_input_text');
        if (this.files && this.files.length > 0) parentDiv.addClass('file-added');
        else parentDiv.removeClass('file-added');
    });

    function parseAccept(a) {
        if (!a) return [];
        var arr = [];
        $.each(a.split(','), function(_, s){
            var v = $.trim(s).toLowerCase();
            if (v) arr.push(v);
        });
        return arr;
    }
    function hasAllowedExt(name, exts) {
        var i = name.lastIndexOf('.');
        if (i === -1) return false;
        var ext = name.slice(i).toLowerCase();
        return $.inArray(ext, exts) !== -1;
    }
    function validateFiles(files, exts) {
        if (!exts.length) return true;
        for (var i=0;i<files.length;i++) if (!hasAllowedExt(files[i].name, exts)) return false;
        return true;
    }

    $(document).on('dragover', function(e){
        e.preventDefault();
    });
    $(document).on('drop', function(e){
        if (!$(e.target).closest('.no-margin.type_input_text').length) {
            e.preventDefault();
        }
    });

    $(document).on('dragover', '.no-margin.type_input_text', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).addClass('drag-over');
    });
    $(document).on('dragleave', '.no-margin.type_input_text', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).removeClass('drag-over');
    });
    $(document).on('drop', '.no-margin.type_input_text', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var input = $(this).find('input[type=file]')[0];
        if (!input) return;
        var files = e.originalEvent && e.originalEvent.dataTransfer ? e.originalEvent.dataTransfer.files : null;
        if (!files || !files.length) return;
        var allowed = parseAccept($(input).attr('accept') || '');
        if (!validateFiles(files, allowed)) {
            alert('Failo formatas neleidžiamas.');
            return;
        }
        var dt = new DataTransfer();
        for (var i=0;i<files.length;i++) dt.items.add(files[i]);
        input.files = dt.files;
        $(input).trigger('change');
    });
}


function mobile_overflow_tables() {
	if ($(".content_template").length) {
		$('.content_template table').each(function () {
			var element = $(this);
			// Create the wrapper element
			var scrollWrapper = $('<div />', {
				'class': 'scrollable',
				'html': '<div />' // The inner div is needed for styling
			}).insertBefore(element);
			// Store a reference to the wrapper element
			element.data('scrollWrapper', scrollWrapper);
			// Move the scrollable element inside the wrapper element
			element.appendTo(scrollWrapper.find('div'));
			// Check if the element is wider than its parent and thus needs to be scrollable
			if (element.outerWidth() > element.parent().outerWidth()) {
				element.data('scrollWrapper').addClass('has-scroll');
			}
			// When the viewport size is changed, check again if the element needs to be scrollable
			$(window).on('resize orientationchange', function () {
				if (element.outerWidth() > element.parent().outerWidth()) {
					element.data('scrollWrapper').addClass('has-scroll');
				} else {
					element.data('scrollWrapper').removeClass('has-scroll');
				}
			});
		});
	}
}

function iframe_adaptability() {
	var $container = $(".content_template");
	var $iframes = $("iframe:not([title='reCAPTCHA'])");

	$container.find($iframes).each(function () {
		$(this).wrap("<div class='iframe_wrapper'></div>");
	});
}

function getMoreInstagramPhotos(url) {
	$('.more_btn_cont').remove();
	$('.loader_content').show();
	$.ajax({
		url: url,
		cache: true
	}).done(function (html) {
		$('.instagram_list').append(html);
		$('.loader_content').hide();
	});
}


function reportbug_form() {
	if ($("#reportbug_form_wrapper").length) {
		$(".reportbug_link a").fancybox({
			type: "inline",
			padding: [55, 10, 30, 20],
			margin: [10, 0, 10, 0],
			afterClose: function () {
				$("#reportbug_form_wrapper").removeClass('form-success');
				$(".bugreport_form").find(".bugreport_form_infos").hide();
				$(".bugreport_form").find(".one_item").show();
				$(".bugreport_form").find(".reportbug_submit").show();
				$(".bugreport_form").find(".phpcaptcha_container").show();
			}
		});

		$(".bugreport_form").validate({
			highlight: function (element, errorClass, validClass) {
				if ($(element).closest(".type_item").length) {
					$(element).closest(".type_item").removeClass(validClass).addClass(errorClass);
				}
			},
			unhighlight: function (element, errorClass, validClass) {
				if ($(element).closest(".type_item").length) {
					$(element).closest(".type_item").removeClass(errorClass).addClass(validClass);
				}
			},
			errorPlacement: function (error, element) {
				$(element).closest(".type_item").find('.type_error').append(error);
			},
			submitHandler: function (form) {
				if ($(".bugreport_form").hasClass("currently_sending")) { // if btn inactive
					return false;
				}
				var data = $(form).serialize();
				var base64image = $('.canvas-preview')[0].src;
				if (base64image != '') {
					data += '&image=' + base64image;
				}
				var url = $(form).data("url");
				var $form = $(".bugreport_form");
				$form.addClass("currently_sending");
				$.ajax({
					type: "POST",
					url: url,
					data: data,
					success: function (data) {
						$form.removeClass("currently_sending");
						var $infoc = $(".bugreport_form_infos");
						$infoc.find(".info_cont").fadeOut("fast").html();
						$infoc.find(".error_cont").fadeOut("fast");
						$infoc.find(".error_cont .errors_list").html();
						if ($(".phpcaptcha_container", $form).length) {
							var captchasrc = $form.find("#captcha_value_image").attr("src");
							$form.find("#captcha_value_image").attr("src", captchasrc.split("?")[0] + "?r=" + Math.random());
						}
						if (!data.data.success) {
							$infoc.fadeIn("fast");
							$infoc.find(".error_cont").fadeIn("fast").find(".errors_list").html('<p>' + data.data.errors.join("</p><p>") + '</p>');
							$(".fancybox-inner").animate({scrollTop: 0 + 'px'}, 'fast');

						} else {
							$("#reportbug_form_wrapper").addClass('form-success');
							$infoc.fadeIn("fast");
							$infoc.find(".info_cont").fadeIn("fast").html('<p>' + data.data.message + '</p>');
							$form.find("input").not("[name=" + secure_xsrf_name + "]").val('');
							$('.canvas-preview')[0].src = '';
							$form.find("textarea").val('');
							$form.find(".one_item").fadeOut("fast");
							$form.find(".reportbug_submit").fadeOut("fast");
							$form.find(".phpcaptcha_container").fadeOut("fast");
						}
					}
				});
				return false;
			}
		});
	}
}

function show_more() {
	$('.blocks_container').find('.show_more').click(function () {
		$(this).toggleClass('active');
		$(this).parent('.text_container').next('.block_more_info').slideToggle('fast').toggleClass('open');
	});

	$('.blocks_container').find('.show_less').click(function () {
		$(this).parents('.single_block').find('.show_more').removeClass('active');
		$(this).parent('.block_more_info').slideUp('fast').removeClass('open');
	});

	$('.videos_list').find('.show_video_desc').click(function () {
		$(this).toggleClass('active');
		$(this).next('.resource_video_desc').slideToggle('fast');
	});
}

function postformwidget_validate() {
	var $form = $("#postformwidget_form");
	if ($form.length) {
		$form.validate({
			submitHandler: function (form) {
				if ($form.hasClass("currently_sending")) {
					return false;
				}
				var data = $(form).serialize();
				var url = $(form).data("url");
				$form.addClass("currently_sending");
				$.ajax({
					type: "POST",
					url: url,
					data: data,
					success: function (data) {
						$form.removeClass("currently_sending");
						var $infoc = $(".postformwidget_infos");
						$infoc.find(".info_cont").fadeOut("fast").html();
						$infoc.find(".error_cont").fadeOut("fast");
						$infoc.find(".error_cont .errors_list").html();
						if (!data.data.success) {
							$infoc.fadeIn("fast");
							$infoc.find(".error_cont").fadeIn("fast").find(".errors_list").html('<p>' + data.data.errors.join("</p><p>") + '</p>');
						} else {
							$infoc.fadeIn("fast");
							$infoc.find(".info_cont").fadeIn("fast").html('<p>' + data.data.message + '</p>');
							$form.find("input").val('');
							$form.find("textarea").val('');
							$form.find(".input_holder").fadeOut("fast");
							$form.find(".contact_block_title").fadeOut("fast");
							$form.find(".recaptcha_cont").fadeOut("fast");
							$form.find(".button_holder").fadeOut("fast");
							setTimeout(function () {
								$(window).trigger('resize');
							}, 450);
						}
					}
				});
				return false;
			}
		});
	}
}

function init_contacts() {
	if ($(".contacts_struct_cont").length) {
		$('#search_by_field').change(function () {
			$('#search_by_label').text($("#search_by_field option[value='" + $(this).val() + "']").text());
		});
	}
}

// http://iamceege.github.io/tooltipster/
function tooltipster() {
	if ($(".tooltip").length) {
		$('.tooltip').tooltipster({
			delay: 15
		});
	}
}

function sidebar_menu() {
	if ($(".submenu_block").length > 0) {
		var $parent = $(".submenu_block");
		var $icons = $parent.find('.icon-chevron-down');

		if ($icons.length > 0) {
			$icons.each(function () {
				var sliding = false;

				$(this).click(function (e) {
					e.preventDefault();

					if (!sliding) {
						sliding = true;

						if (!$(this).parents('li').hasClass('show')) {
							$(this).parents('ul').children('li.show').removeClass('show').children('ul').slideUp(150);
							$(this).parents('ul').children('li').removeClass('prev next');
						}

						$(this).parents('li').toggleClass('show').removeClass('prev next');
						$(this).parents('li').prev().toggleClass('prev');
						$(this).parents('li').next().toggleClass('next');
						$(this).parent().next().slideToggle(150, function () {
							sliding = false;
						});
					}
				});
			});
		}
	}
}

function scroll_top() {
	if ($('.scroll_top').length > 0) {
		$('.scroll_top button').click(function () {
			$('html, body').animate({
				scrollTop: 0
			}, 300);
		});
	}
}

// titlepage calendar
var calendar_data = {
	baseurl: '',
	month: ''
};

function set_widgetcalendar_data() {
	calendar_data.baseurl = $('#widget_calendar').data('baseurl');
	calendar_data.month = $('#widget_calendar').data('month');
}

function getCalendarMonth(month) {
	loadMonth(month);
}

function loadMonth(month) {
	calendar_data.month = month;
	loadCalendar();
}

function loadCalendar() {
	$.ajax({
		url: calendar_data.baseurl + '/' + calendar_data.month,
		cache: false
	}).done(function (html) {
		$('#events_calendar').html(html);
		showDayEvent();
		showCurrentMonthEvents();
	});
}

function showDayEvent() {
	var activeDay = $('#widget_calendar .calendar_container .day.active');
	var $calendar_cont = $('.events_calendar_block');

	if ($("#widget_calendar .calendar_container").length > 0) {
		activeDay.each(function () {
			var $day = $(this);
			$day.on("click", function (e) {
				e.stopPropagation();
				activeDay.removeClass('selected');
				$day.addClass('selected');
				$calendar_cont.find('.firstload').hide();
				$calendar_cont.find('.day_events').hide();
				$calendar_cont.find('.day_events[data-selected-day="' + $day.data('day') + '"]').show();
			});
		});
	}
}

function showCurrentMonthEvents() {
	var days = document.querySelectorAll('.items_list .day_events');
	var i = 0;
	var event_list = [];

	for (i; i < days.length; i++) {
		var dataid = days[i].getAttribute('data-id');
		var includes = event_list.includes(dataid);

		if (null !== dataid && !includes) {
			days[i].classList.add('show');
			event_list.push(dataid);
		}
	}

	if (event_list.length < 1) {
		showNoEventMessage();
	}
}

function showNoEventMessage() {
	var container = document.querySelector('.section_events .items_list');
	if (null !== container) {
		var element = document.createElement('span');
		element.innerHTML = no_events;
		element.classList.add('no_tasks');
		container.appendChild(element);
	}
}

function EventCalendar(params) {
	var self = this;
	var calendar = {
		calendar_query: {
			category_id: 0,
			location_id: 0,
			month: '', //$("#content_calendar").attr('data-month')
			innerpage: 1,
			year: 0,
		},
		calendar_data: {
			baseurl: '',
			month: '',
			day: ''
		}
	};

	calendar.init = function () {
		calendar.set_widgetcalendar_data();
		calendar.calendarFilters();
//		calendar.calendarPaginate();
		calendar.showDayEventInner();
		calendar.changeMonth();
	};


	calendar.set_widgetcalendar_data = function () {
		calendar.calendar_data.baseurl = $('#widget_calendar').data('baseurl');
		calendar.calendar_data.month = $('#widget_calendar').data('month');
	};

	calendar.changeMonth = function () {
		$('.eventscalendar_list .prev_month, .eventscalendar_list .next_month').click(function () {
			calendar.getCalendarMonthInner($(this).attr('data-id'));
		});
	};

	calendar.getCalendarMonthInner = function (month) {
		calendar.calendar_query.month = month;
		calendar.loadMonthInner();
	};

	calendar.loadMonthInner = function () {
		calendar.loadCalendarInner();
	};

	calendar.calendarFilters = function () {
		$(".filters .categories").change(function () {
			calendar.calendar_query.category_id = $(this).val();
			calendar.loadMonthInner();
		});

		$(".filters .locations").change(function () {
			calendar.calendar_query.location_id = $(this).val();
			calendar.loadMonthInner();
		});

		$(".filters .years").change(function () {
			calendar.calendar_query.year = $(this).val();
			calendar.getCalendarMonthInner($(this).val());
		});

		$(".filters .limit").change(function () {
			$(".filters .limit .item").removeClass('active');
			$(this).addClass('active');
			calendar.calendarPaginate($(this).val());
		});
	};

	calendar.clearCalendarFilters = function () {
		calendar.calendar_query.location_id = 0;
		calendar.calendar_query.year = 0;
		calendar.calendar_query.month = '';
		calendar.calendar_query.category_id = 0;
		calendar.loadMonthInner();
	}

	calendar.initClearCalendarFiltersBtn = function () {
		var btns = document.querySelectorAll('.filters .clear_filter');
		if (null === btn) {
			return;
		}

		for (var i = 0; i < btns.length; i++) {
			var btn = btns[i];
			btn.addEventListener('click', calendar.clearCalendarFilters);
		}
	};

	calendar.loadCalendarInner = function (month) {
		var $calendar_cont = $('#content_calendar');
		var url = $calendar_cont.data('baseurl');
		var url_month = calendar.calendar_query.month;
		if (url_month == '') {
			url_month = $("#content_calendar").attr('data-month');
		}
		var ajaxUrl = url + '/' + url_month;//calendar.calendar_query.month
		$.ajax({
			url: ajaxUrl,
			cache: false,
			data: calendar.calendar_query
		}).done(function (html) {
			$calendar_cont.html(html).promise().done(function (arg1) {
				$('.eql_event').responsiveEqualHeightGrid();
				select2init();
				toggle_items();
			});
			calendar.showDayEventInner();
			calendar.changeMonth();
			calendar.initClearCalendarFiltersBtn();
		});
	};

	calendar.showDayEventInner = function (fromAjax) {
		var $calendar_cont = $('#content_calendar');
		var loader = $('#content_calendar').find('.loader_item');
		loader.hide();

		if ($calendar_cont.length > 0 && $("#events_calendar").length > 0) {
			$('.day_withevents.active .day_number').each(function () {
				$(this).on("click", function (e) {
					e.stopPropagation();
					var $tm;
					var $day = $(this);
					clearTimeout($tm);
					$('.day_withevents.active').removeClass('selected');
					$(this).parent().addClass('selected');
					$calendar_cont.find('.day_events:not(.calendar_item):not(.loader_item):not(.empty_item)').hide();
					$('.pagination-container').hide();
					loader.show();
					calendar.calendar_data.day = $day.data('day');
					$tm = setTimeout(function () {
						loader.hide();
						$calendar_cont.find('.day_events[data-selected-day="' + $day.data('day') + '"]').show();
						calendar.calendarPaginate();
					}, 300);

				});
			});

			if ($('.day_withevents.active.current').length > 0) {
				$('.day_withevents.active.current .day_number').trigger('click').addClass('open');
			} else if ($('.day_withevents.active').length > 0) {
				$($('.day_withevents.active .day_number')[0]).trigger('click').addClass('open');
			}

			calendar.calendarFilters();
		}

	};

	calendar.calendarPaginate = function (perpage) {
		if ($('.eventscalendar_list .list').length > 0 && calendar.calendar_data.day) {

			$(".eventscalendar_list .pagination-container").remove();

			if (typeof (perpage) === 'undefined') {
				var perpage = $("#content_calendar").attr('data-perpage');
			}
			$('.eventscalendar_list .list .day_events[data-selected-day="' + calendar.calendar_data.day + '"]').paginathing({
				perPage: perpage,
				firstLast: false,
				prevText: "&lsaquo;",
				nextText: '&rsaquo;'
			});
		}
	};

	calendar.init();
}

function loadTitlepageCalendar() {
	if ($('.tp_widget_calendar').length > 0 && typeof $('.tp_widget_calendar').data('month') !== 'undefined' && $('.tp_widget_calendar').data('month') !== '') {
		getCalendarMonth($('.tp_widget_calendar').data('month'));
	}
}

function toggle_items() {
	$('.btn_toggle').click(function () {
		$(this).parent().parent().find('.toggle_content').toggleClass('active');
		$(this).toggleClass('rotate');
	});
}

function addAriaLabelToMobileMenu() {
	var elementsList = document.querySelectorAll('a.mm-next');

	if (elementsList.length < 1) {
		return;
	}

	for (var i = 0; i < elementsList.length; i++) {
		var element = elementsList[i];
		element.setAttribute('aria-label', globalJsTranslations().getTr('next'));
	}
}

// Chartjs
var htmlLegendPlugin = {
	id: 'htmlLegend',
	afterUpdate: function (chart, args, options) {
		var legendContainer = document.getElementById(options.containerID);

		// Remove old legend labels
		while (legendContainer.firstChild) {
			legendContainer.firstChild.remove();
		}

		// Reuse the built-in legendItems generator
		var labels = chart.options.plugins.legend.labels.generateLabels(chart);

		labels.forEach(function (label) {
			var div = document.createElement('div');
			div.classList.add('chart-legend__item');

			// Color box
			var colorBox = document.createElement('span');
			colorBox.classList.add('icon');
			colorBox.style.background = label.fillStyle;
			div.appendChild(colorBox);

			// Text box
			var textBox = document.createElement('span');
			textBox.classList.add('text');
			textBox.classList.add('text1320');
			textBox.textContent = label.text;
			div.appendChild(textBox);

			if (chart.config.type == 'pie' || chart.config.type == 'doughnut') {
				// Value box
				var valueBox = document.createElement('span');
				valueBox.classList.add('value');
				valueBox.classList.add('text1320');
				valueBox.textContent = chart.data.datasets[0].data[label.index];
				div.appendChild(valueBox);
			}

			legendContainer.appendChild(div);
		});
	}
};

var customChartJsTooltip = {
	enabled: false,

	external: function (context) {
		// Tooltip Element
		var tooltipEl = document.getElementById('chartjs-tooltip');

		// Create element on first render
		if (!tooltipEl) {
			tooltipEl = document.createElement('div');
			tooltipEl.id = 'chartjs-tooltip';
			tooltipEl.classList.add('chartjs-tooltip');
			document.body.appendChild(tooltipEl);
		}

		// Hide if no tooltip
		var tooltipModel = context.tooltip;
		if (tooltipModel.opacity === 0) {
			tooltipEl.style.opacity = 0;
			return;
		}

		// Set caret Position
		tooltipEl.classList.remove('above', 'below', 'no-transform');
		if (tooltipModel.yAlign) {
			tooltipEl.classList.add(tooltipModel.yAlign);
		} else {
			tooltipEl.classList.add('no-transform');
		}

		function getDataValue(item) {
			return item.formattedValue;
		}

//		Set Text
		if (tooltipModel.dataPoints) {
			var titleLines = tooltipModel.title || [];
			var bodyLines = tooltipModel.dataPoints.map(getDataValue);
			var innerHtml = '';

			// Head content
			if (titleLines.length > 0) {
				innerHtml += '<div class="chartjs-tooltip__h">';
				titleLines.forEach(function (title) {
					innerHtml += '<div class="chartjs-tooltip__h-item">' + title + '</div>';
				});
				innerHtml += '</div>';
			}
			// Head content END

			// Body content
			innerHtml += '<div class="chartjs-tooltip__b">';
			bodyLines.forEach(function (body, i) {
				var colors = tooltipModel.labelColors[i];
				var style = 'background:' + colors.backgroundColor;
				var span = '<span class="color" style="' + style + '"></span>';
				innerHtml += '<div class="chartjs-tooltip__b-item">' + span + body + '</div>';
			});
			innerHtml += '</div>';
			// Body content END

			tooltipEl.innerHTML = innerHtml;
		}
//
		var position = context.chart.canvas.getBoundingClientRect();

		// Display, position, and set styles for font
		tooltipEl.style.opacity = 1;
		tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.x + 'px';
		tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.y + 'px';
//		tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
//		tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
	}
};

function doScreenshot() {
	$('body').addClass('loading-page');
	html2canvas(document.body, {}).then(function (canvas) {
		$('body').removeClass('screenshot-mode');
		$('#bbox').hide();
		$('.canvas-preview')[0].src = canvas.toDataURL("image/png");

		$('#screenshot-preview-holder').fancybox({
			afterClose: function () {
				$("#screenshot-preview-holder").show();
			}
		});
		$('body').removeClass('loading-page');
	});
}

function markSpot() {
	$('body').addClass('screenshot-mode');

	var x, y, oldx, oldy;
	var showDrag = false;

	$(document).on("mousedown", "body.screenshot-mode", function (e) {
		oldx = e.clientX;
		oldy = e.clientY;
		showDrag = true;
		e.preventDefault();
	});
	$(document).on("mousemove", "body.screenshot-mode", function (e) {
		if (showDrag == true) {
			x = e.clientX;
			y = e.clientY;
			var bbox = $("#bbox")[0];
			var contbox = $("body.screenshot-mode")[0];
			var w = (x > oldx ? x - oldx : oldx - x);
			var h = (y > oldy ? y - oldy : oldy - y);
			var addx = 0, addy = 0;
			if (x < oldx) {
				addx = w;
			}
			if (y < oldy) {
				addy = h;
			}
			bbox.style.left = (oldx - parseInt((contbox.offsetLeft + addx))) + "px";
			bbox.style.top = (oldy + parseInt((window.pageYOffset + addy))) + "px";
			bbox.style.width = w + "px";
			bbox.style.height = h + "px";
			bbox.style.display = "block";
		}
		e.preventDefault();
	});
	$(document).on("mouseup", "body.screenshot-mode", function (e) {
		showDrag = false;
		e.preventDefault();
		doScreenshot();
	});
}

function pikaday() {
	const datePickerElements = document.querySelectorAll('.datepicker');

	datePickerElements.forEach(datePickerElement => {
		const today = new Date();
		new Pikaday({
			field: datePickerElement,
			format: 'YYYY-MM-DD',
			firstDay: 1,
			autocomplete: false,
			showDaysInNextAndPreviousMonths: false,
			toString(date) {
				return moment(date).format('YYYY-MM-DD');
			},
			parse(dateString) {
				return moment(dateString, 'YYYY-MM-DD').toDate();
			},
			i18n: {
				previousMonth: '',
				nextMonth: '',
				months: moment.localeData().months(),
				weekdays: moment.localeData().weekdays(),
				weekdaysShort: moment.localeData().weekdaysShort()
			},
		});
	});
}
function addAriaLabels() {
	// Add 'aria-label' to elements with 'g-recaptcha-response'
	document.querySelectorAll('.g-recaptcha-response').forEach(element => {
		element.setAttribute('aria-label', 'google recaptcha');
	});

	// Add 'aria-label' to elements with 'NFI-filename'
	document.querySelectorAll('.NFI-filename').forEach(element => {
		element.setAttribute('aria-label', 'failas');
	});
	const delay = 500;

	setTimeout(addAriaLabels, delay);
}

function langToggle() {
	$('.header__langs > div').on('click', function (e) {
		e.stopPropagation(); // Prevent the click from propagating to the document
		$(this).toggleClass('active'); // Toggle the 'active' class
	});

	$(document).on('click', function () {
		$('.header__langs > div').removeClass('active'); // Remove 'active' from all instances
	});
}

function navToggle() {
	// Hover with mouse
	$(document).on('mouseover', '.topnav--toggleable > ul > li > a.has-childs', function () {
		const $parentLi = $(this).parent('li');
		$parentLi.siblings().removeClass('toggle-on');
		$parentLi.addClass('toggle-on');
	});

	// Remove on mouse leave
	$(document).on('mouseleave', '.topnav--toggleable > ul > li', function () {
		const $this = $(this);
		setTimeout(function () {
			if (!$this.is(':hover') && !$this.find(':focus').length) {
				$this.removeClass('toggle-on childs-toggle-on');
				$this.find('a.has-childs').removeClass('opened');
			}
		}, 200);
	});

	// Close when clicking outside
	$(document).on('click', function (e) {
		if (!$(e.target).closest('.topnav--toggleable > ul').length) {
			$('.topnav--toggleable > ul > li').removeClass('toggle-on childs-toggle-on');
			$('.topnav--toggleable > ul > li a.has-childs').removeClass('opened');
		}
	});

	// Toggle submenus on click
	$(document).on('click', '.topnav--toggleable > ul > li.toggle-on .menu-block a.has-childs', function (e) {
		e.preventDefault();
		const $parentLi = $(this).parent('li');
		$(this).toggleClass('opened');
		$parentLi.siblings().removeClass('childs-toggle-on');
		$parentLi.toggleClass('childs-toggle-on');
		$parentLi.siblings().find('a.has-childs').removeClass('opened');
	});

	// --- Keyboard Support ---
	// Open menu on focus (via Tab)
	$(document).on('focus', '.topnav--toggleable > ul > li > a.has-childs', function () {
		const $parentLi = $(this).parent('li');
		$parentLi.siblings().removeClass('toggle-on');
		$parentLi.addClass('toggle-on');
	});

	// Close menu when focus leaves the list item
	$(document).on('focusout', '.topnav--toggleable > ul > li', function () {
		const $this = $(this);
		setTimeout(function () {
			if (!$this.find(':focus').length) {
				$this.removeClass('toggle-on childs-toggle-on');
				$this.find('a.has-childs').removeClass('opened');
			}
		}, 200);
	});

	// Toggle submenu on Enter or Space key
	$(document).on('keydown', '.topnav--toggleable > ul > li > a.has-childs', function (e) {
		const $parentLi = $(this).parent('li');

		// Open/close on Enter or Space
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			$(this).toggleClass('opened');
			$parentLi.toggleClass('childs-toggle-on').siblings().removeClass('childs-toggle-on');
			$parentLi.siblings().find('a.has-childs').removeClass('opened');
		}

		// Skip to next top-level link with Arrow Right
		if (e.key === "ArrowRight") {
			e.preventDefault();
			const $nextTopLevel = $parentLi.next('li').find('> a').first();
			if ($nextTopLevel.length) {
				$nextTopLevel.focus();
			} else {
				// Loop back to the first one if at the end
				$('.topnav--toggleable > ul > li').first().find('> a').first().focus();
			}
		}
	});
}

function checkActiveTags() {
	// Select all inputs with the 'active' class inside '.kgbdocuments__tags'
	const activeInputs = document.querySelectorAll('.kgbdocuments__tags input.active');

	// Loop through each active input and set its checked property to true
	activeInputs.forEach(input => {
		input.checked = true;
	});
}

const toggle_search_popup = () => {
	const search_button = document.querySelector(".header__search");
	const search_overlay = document.querySelector(".search_overlay");
	const search_exit = document.querySelector(".search_overlay .search_exit");
	const search_popup = document.querySelector(".search_overlay .search_popup");
	const header_popup_search_input = document.getElementById("header_popup_search_input");

	const toggle_visibility = () => {
		search_overlay.classList.toggle("show");

		if (search_popup.style.overflow === 'auto') {
			search_popup.style.overflow = 'hidden';
		} else {
			setTimeout(() => {
				search_popup.style.overflow = 'auto';
			}, 500);
		}

		// Focus input after opening
		setTimeout(() => {
			if (search_overlay.classList.contains("show")) {
				header_popup_search_input.focus();
			}
		}, 100);
	};

	// --- Open the popup ---
	search_button.addEventListener('click', (e) => {
		e.preventDefault();
		toggle_visibility();
	});
	search_button.addEventListener('keydown', (e) => {
		if (e.key === "Enter") {
			e.preventDefault();
			toggle_visibility();
		}
	});

	// --- Close popup with search_exit ---
	search_exit.addEventListener('click', toggle_visibility);
	search_exit.addEventListener('keydown', (e) => {
		if (e.key === "Enter" || e.key === " ") { // Enter or Space triggers close
			e.preventDefault();
			toggle_visibility();
		}
	});

	// --- Close when clicking outside popup ---
	search_overlay.addEventListener('click', (event) => {
		if (event.target === search_overlay) {
			toggle_visibility();
		}
	});

	// --- Close popup with Enter or Escape anywhere inside overlay ---
	search_overlay.addEventListener('keydown', (e) => {
		if (e.key === "Escape") {
			e.preventDefault();
			toggle_visibility();
		}
	});

	// --- Auto-close on resize below 1024px ---
	window.addEventListener('resize', () => {
		if (window.innerWidth <= 1024) {
			search_overlay.classList.remove("show");
			search_popup.style.overflow = 'hidden';
		}
	});
};

function formControl() {
	// Make radio and checkbox focusable via Tab
	$('input[type="radio"], input[type="checkbox"]').attr('tabindex', '0');

	// Handle keyboard navigation
	$('input[type="radio"], input[type="checkbox"]').on('keydown', function (e) {
		if (e.key === "Enter") {
			e.preventDefault(); // Prevent default form submission behavior
			$(this).prop('checked', true).trigger('change');
		}

		if (e.key === " ") {
			e.preventDefault(); // Prevent page scrolling
			if ($(this).attr('type') === 'checkbox') {
				$(this).prop('checked', !$(this).prop('checked')).trigger('change');
			} else if ($(this).attr('type') === 'radio') {
				$(this).prop('checked', true).trigger('change');
			}
		}
	});

	// Ensure focus styling is visible
	$('input[type="radio"], input[type="checkbox"]').on('focus', function () {
		$(this).next('.radio_design, .checkbox_design').addClass('focused');
	}).on('blur', function () {
		$(this).next('.radio_design, .checkbox_design').removeClass('focused');
	});

	$(document).on('focus', "input[type='file']", function () {
		$(this).closest('.type_answers').css('outline', '1px solid #212121');
	});

	$(document).on('blur', "input[type='file']", function () {
		$(this).closest('.type_answers').css('outline', 'none');
	});
	// Make .NFI-filename non-focusable
	$('.NFI-filename').attr('tabindex', '-1').css('pointer-events', 'none');
}

function contactsControl() {
	$(".contacts__list-item").on("click", function (e) {
		e.preventDefault();
		var contactId = $(this).attr("data-src").replace("#contact-info-", ""); // Extract ID
		var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?contact=" + contactId;
		history.pushState({path: newUrl}, "", newUrl); // Update URL

		$.fancybox.open({
			src: "#contact-info-" + contactId,
			touch: false,
			smallBtn: true,
			toolbar: false,
			buttons: ["close"],
			autoFocus: false,
			baseClass: "contacts-fancybox-modal",
			afterShow: function (instance, current) {
				$(".fancybox-container").addClass("custom-modal-class");
			},
			afterClose: function () {
				history.pushState(null, "", window.location.pathname); // Reset URL on close
			}
		});
	});

	function openContactFromUrl() {
		var urlParams = new URLSearchParams(window.location.search);
		var contactId = urlParams.get("contact");

		if (contactId) {
			$.fancybox.open({
				src: "#contact-info-" + contactId,
				touch: false,
				smallBtn: true,
				toolbar: false,
				buttons: ["close"],
				autoFocus: false,
				baseClass: "contacts-fancybox-modal",
				afterShow: function (instance, current) {
					$(".fancybox-container").addClass("custom-modal-class");
				},
				afterClose: function () {
					history.pushState(null, "", window.location.pathname); // Reset URL on close
				}
			});
		}
	}
	openContactFromUrl();

	$(document).ready(function () {
		$('.cat-block__header.toggler').on('click', function (e) {
			e.preventDefault();
			var $block = $(this).closest('.cat-block');
			$block.toggleClass('open');
			$(this).find('.icon-arrow-down').toggleClass('open');
		});
	});

	window.filterGlobalnewsContent = function () {
		var year = document.querySelector('#selected_year') ? document.querySelector('#selected_year').value : null;
		var month = document.querySelector('#selected_month') ? document.querySelector('#selected_month').value : null;
		var categoryElement = document.querySelector('#category_id');
		var categoryId = categoryElement ? categoryElement.value : null;
		var url = filterSubimitUrl;

		if (url === '') {
			return;
		}

		if (year && year > 0) {
			url += '/_' + year;
			if (month && month > 0) {
				url += '-' + ((month > 9) ? month : '0' + month);
			}
		}

		if (categoryId && categoryId > 0) {
			url += '/c' + categoryId;
		}

		window.location = url;
	};

}